"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _tslib = require("tslib");

var _Semaphore = _interopRequireDefault(require("./Semaphore"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Mutex =
/** @class */
function () {
  function Mutex() {
    this._semaphore = new _Semaphore.default(1);
  }

  Mutex.prototype.acquire = function () {
    return (0, _tslib.__awaiter)(this, void 0, void 0, function () {
      var _a, releaser;

      return (0, _tslib.__generator)(this, function (_b) {
        switch (_b.label) {
          case 0:
            return [4
            /*yield*/
            , this._semaphore.acquire()];

          case 1:
            _a = _b.sent(), releaser = _a[1];
            return [2
            /*return*/
            , releaser];
        }
      });
    });
  };

  Mutex.prototype.runExclusive = function (callback) {
    return this._semaphore.runExclusive(function () {
      return callback();
    });
  };

  Mutex.prototype.isLocked = function () {
    return this._semaphore.isLocked();
  };

  Mutex.prototype.release = function () {
    this._semaphore.release();
  };

  return Mutex;
}();

var _default = Mutex;
exports.default = _default;